import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router-dom';
import logo from './images/logo_dashbo_white.svg';
import './sass/pages/_not-found.scss';

export function PageNotFound() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <NotFoundContent t={t} onGoHome={() => navigate('/')} onGoBack={() => navigate(-1)} />
    );
}

export function RouterErrorPage() {
    const { t } = useTranslation();
    const error = useRouteError();
    const navigate = useNavigate();

    const is404 = error?.status === 404 || error?.statusText === 'Not Found';

    if (is404) {
        return <NotFoundContent t={t} onGoHome={() => navigate('/')} onGoBack={() => navigate(-1)} />;
    }

    return (
        <div className="not-found-page">
            <div className="not-found-container">
                <div className="not-found-logo">
                    <img src={logo} alt="Dashbo" className="not-found-logo-icon" />
                </div>
                <h1 className="not-found-code">500</h1>
                <p className="not-found-title">{t('error_boundary.something_went_wrong')}</p>
                <p className="not-found-description">{t('error_boundary.unexpected_error_message')}</p>
                <div className="not-found-actions">
                    <button className="not-found-btn -primary" onClick={() => window.location.reload()}>
                        {t('error_boundary.reload_page')}
                    </button>
                    <button className="not-found-btn -secondary" onClick={() => navigate('/')}>
                        {t('not_found.go_home')}
                    </button>
                </div>
            </div>
            <div className="not-found-decoration">
                <div className="not-found-circle -one"></div>
                <div className="not-found-circle -two"></div>
                <div className="not-found-circle -three"></div>
            </div>
        </div>
    );
}

function NotFoundContent({ t, onGoHome, onGoBack }) {
    return (
        <div className="not-found-page">
            <div className="not-found-container">
                <div className="not-found-logo">
                    <img src={logo} alt="Dashbo" className="not-found-logo-icon" />
                </div>
                <h1 className="not-found-code">404</h1>
                <p className="not-found-title">{t('not_found.title')}</p>
                <p className="not-found-description">{t('not_found.description')}</p>
                <div className="not-found-actions">
                    <button className="not-found-btn -primary" onClick={onGoHome}>
                        {t('not_found.go_home')}
                    </button>
                    <button className="not-found-btn -secondary" onClick={onGoBack}>
                        {t('not_found.go_back')}
                    </button>
                </div>
            </div>
            <div className="not-found-decoration">
                <div className="not-found-circle -one"></div>
                <div className="not-found-circle -two"></div>
                <div className="not-found-circle -three"></div>
            </div>
        </div>
    );
}
